import { useContext, useDebugValue } from "react";
// import AuthContext from "../context/AuthProvider";
import { userContext } from "../context/UserRoleContext";

const useAuth = () => {
  const context = useContext(userContext); // Get the full context
  useDebugValue(context.authenticated, (auth) =>
    auth?.user ? "Logged In" : "Logged Out"
  );
  return context;
};

export default useAuth;
